module.exports = __webpack_public_path__ + "img/ALTERNA.6345cb7d.png";